/* eslint-disable max-len */
import React from 'react'

import { string } from 'prop-types'

function Furniture(props) {
  return (
    <svg
      {...props}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.0002 1.74999C15.4142 1.75017 15.7502 2.08589 15.7502 2.49999V9.24999H15.8341C16.2481 9.25034 16.5841 9.58599 16.5841 9.99999C16.5841 10.414 16.2481 10.7496 15.8341 10.75H15.2502L11.2492 13.75L15.4503 16.9004C15.7814 17.1489 15.849 17.6189 15.6007 17.9502C15.3523 18.2815 14.8823 18.3479 14.5509 18.0996L10.0002 14.6865L5.45035 18.0996C5.11908 18.3481 4.64913 18.2813 4.40054 17.9502C4.15201 17.6188 4.21956 17.1489 4.55093 16.9004L8.75113 13.75L4.75113 10.75H4.16714C3.75293 10.75 3.41714 10.4142 3.41714 9.99999C3.41714 9.58578 3.75293 9.24999 4.16714 9.24999H4.25015V2.49999C4.25015 2.08589 4.58609 1.75017 5.00015 1.74999C5.41422 1.75017 5.75015 2.08589 5.75015 2.49999V3.41698H14.2502V2.49999C14.2502 2.08589 14.5861 1.75017 15.0002 1.74999ZM10.0002 12.8125L12.7511 10.75H7.25015L10.0002 12.8125ZM5.75015 9.24999H14.2502V7.41698H5.75015V9.24999ZM5.75015 5.91698H14.2502V4.91698H5.75015V5.91698Z"
        fill="#35424F"
      />
    </svg>
  )
}

Furniture.propTypes = {
  className: string,
  height: string,
  width: string,
}

export default Furniture
